import { FC, CSSProperties } from 'react';
import { Severity } from '@agilelab/plugin-wb-governance-common';
import { useTheme } from '@material-ui/core';
import { WbInfoTooltip } from '../../WbInfoTooltip';
import InfoIcon from '@material-ui/icons/Info';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { WbBadge } from '../../WbBadge';
import { useStyles } from './style';

interface Props {
  severity?: Severity;
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

export const InformationIcon: FC<Props> = ({
  severity,
  style,
  variant = 'default',
}) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <WbInfoTooltip
      variant={variant === 'reduced' ? undefined : 'provided-button'}
      title={`Failed with severity ${
        severity ?? 'INFO'
      }. This policy is just a warning, and will not block the deployment, but remember to check what errors made it fail`}
      icon={
        variant === 'reduced' ? (
          <span>
            <InfoIcon
              className={`${classes.icon}`}
              htmlColor={theme.palette.primary.main}
              style={{ ...style, transform: 'scale(1.2)' }}
            />
          </span>
        ) : (
          <WbBadge
            color="info"
            startIcon={<InfoOutlinedIcon fontSize="small" />}
          >
            Info
          </WbBadge>
        )
      }
    />
  );
};
